import { createFileRoute } from "@tanstack/react-router";
import SeguimientoAutomatico from "../../pages/soluciones/SeguimientoAutomatico";

export const Route = createFileRoute("/que-hacemos/seguimiento-automatico")({
  component: SeguimientoAutomatico,
});
